import FormueberegnerHeader from './FormueberegnerHeader';

export default FormueberegnerHeader;
